export const spacing = 10

export const radii = {
  small: 4,
  default: 6,
  medium: 8,
  large: 12,
}
